import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "signup"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = { class: "lead" };
const _hoisted_8 = { class: "bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import { UserType } from '@util/Consts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'signup_send',
    props: {
        common: {},
        email: {},
        type: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common,
                    type: props.type
                }, null, 8, ["common", "type"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (props.type == _unref(UserType).MENTOR)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "メンター申請登録"))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_5, "新規会員登録")),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _cache[0] || (_cache[0] = _createElementVNode("p", null, [
                                        _createTextVNode(" ShareMentorsへのご登録ありがとうございます。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" ご登録のメールアドレスに確認メールをお送りしました。 ")
                                    ], -1)),
                                    _createElementVNode("p", null, _toDisplayString(props.email), 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
                                        _createTextVNode(" お届けしたメール内のURLリンクをクリックして会員登録を続けてください。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" まだ会員登録は完了しておりません。 ")
                                    ], -1))
                                ]),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w_sub" }, [
                                    _createElementVNode("p", null, [
                                        _createTextVNode(" ※メールに記載したURLリンクの有効期限は24時間です。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 有効期限が切れた場合は再度メールアドレスの入力を行ってください。 ")
                                    ]),
                                    _createElementVNode("p", null, [
                                        _createTextVNode(" ※確認メールが届かない場合"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 迷惑メールフォルダに振り分けられていることもありますのでご確認ください。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" また、「@sharementors.jp」ドメインの受信を可能に設定してください。 ")
                                    ])
                                ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_unref(Link), {
                                    href: "/",
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("ホームに戻る")
                                    ])),
                                    _: 1,
                                    __: [3]
                                })
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
